import { colors } from "colors"
import { StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  accordionContainer: {
    backgroundColor: colors.lightestGrey,
    borderRadius: 10,
    marginTop: 20,
    padding: 10,
  },
  accordionContentContainer: {
    borderColor: colors.placeholder,
    borderTopWidth: 1,
    marginVertical: 5,
    paddingHorizontal: 10,
  },
  accordionTitleContainer: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  buttonContainer: { borderRadius: 20 },
  buttonText: { fontSize: 18 },
  calendarContainer: { alignItems: "center", flexDirection: "row", marginBottom: 10 },
  container: { height: "100%", padding: 10 },
  dateText: { fontFamily: typography.primary.normal, fontSize: 12, marginLeft: 5 },
  description: { fontFamily: typography.primary.normal, marginTop: 10 },
  headerLeftButton: {
    alignItems: "center",
    backgroundColor: colors.lightGrey,
    borderRadius: 99,
    height: 40,
    justifyContent: "center",
    left: 10,
    position: "absolute",
    top: 30,
    width: 40,
    zIndex: 99,
  },
  headerRightButton: {
    alignItems: "center",
    backgroundColor: colors.lightGrey,
    borderRadius: 99,
    height: 40,
    justifyContent: "center",
    position: "absolute",
    right: 10,
    top: 30,
    width: 40,
    zIndex: 99,
  },
  image: { width: "100%" },
  stickyBottomContainer: {
    backgroundColor: colors.white,
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    bottom: 0,
    elevation: 1,
    justifyContent: "center",
    paddingBottom: 30,
    padding: 10,
    position: "absolute",
    shadowColor: colors.black,
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    width: "100%",
  },
  tagContainer: {
    alignItems: "center",
    borderRadius: 5,
    paddingHorizontal: 10,
    paddingVertical: 1,
    width: 80,
  },
  tagText: { color: colors.white, fontSize: 12 },
  title: {
    fontFamily: typography.primary.normal,
    fontSize: 20,
    marginBottom: 10,
    marginTop: 5,
  },
})
